<template>
  <div class="row">
    <div
      v-for="item in items"
      :key="item.id"
      class="col-lg-6 col-md-12 mb-25 wow move-up"
    >
      <div
        class="ht-service-box--three card-premium-feature"
        :style="backgroundFeature(item.bg)"
      >
        <div class="service-box-wrap">
          <div class="image__media">
            <img :src="item.icon" class="img-fluid" alt="Icon" />
          </div>

          <div class="content">
            <h5 class="heading font-weight--light">{{ item.heading }}</h5>
            <div class="service_text">{{ item.text }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaymentFeature",
  data() {
    return {
      items: [
        {
          icon: require("../../assets/img/forum/icono-edu.svg"),
          bg: require("../../assets/img/forum/bg-edu.svg"),
          heading: "Progrentis EDU",
          text: "La primera solución de aprendizaje autoguiado en la  nube, desarrollada con neurofeedback.",
        },
        {
          icon: require("../../assets/img/forum/icono-analitica.svg"),
          bg: require("../../assets/img/forum/bg-analitica.svg"),
          heading: "Progrentis ANALÍTICA",
          text: "El motor de evaluación para obtener una visión 360 del desempeño de los estudiantes.",
        },
      ],
    };
  },
  methods: {
    backgroundFeature(bgImage) {
      const gradient_bg =
        "linear-gradient(83.18deg, #ffe16f 5.94%, #ffcc0d 22.04%, #ffe16f 42.25%)";

      return {
        backgroundImage: `url(${bgImage}), ${gradient_bg}`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.card-premium-feature {
  background-size: contain;
  background-position: bottom;
  background-repeat: no-repeat;
  border-radius: 0 25px 0 25px;

  .heading {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    display: flex;
    align-items: center;
    color: #232735;
  }

  .service_text {
    font-family: "Mulish";
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #2c2e30;
  }
}
</style>
